import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { NewsCreateComponent } from './create/news-create.component';
import { NewsFormComponent } from './form/news-form.component';
import { NewsListComponent } from './list/news-list.component';
import { NewsRestService } from './news-rest.service';
import { NewsRoutingModule } from './news-routing.module';
import { NewsUpdateComponent } from './update/news-update.component';
import { CKEditorModule } from 'ckeditor4-angular';

export const PROVIDERS = [NewsRestService];

@NgModule({
  imports: [
    NewsRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    CKEditorModule
  ],
  declarations: [
    NewsCreateComponent,
    NewsFormComponent,
    NewsListComponent,
    NewsUpdateComponent
  ]
})
export class NewsModule {}
